/* eslint-disable */
<template>
  <div class="text-default font-size-h3 text-center">
    <span>
      Thank you for your booking request for
      <span class="font-weight-bold">
        {{formattedStartDay}}, {{formattedStartDate}} at {{formattedStartTime}}.
      </span>
      This is currently under review and we will send a confirmation email shortly.
    </span>
  </div>
</template>

<script>
/* eslint-disable */
  import { BookingDateTimeMixin } from '@/mixins/Booking/BookingDateTimeMixin';
  
  export default {
    name: 'DisplayUnderReview',
    mixins: [BookingDateTimeMixin]
  }
</script>